import { getCompanyById } from "../Services/Company";
import { getFirmById } from "../Services/Firm";
import IFirm from "../interfaces/models/IFirm";
import { IRegistration } from "../interfaces/models/IRegistration";

export function isGuestAttendeeRegistration(reg: {
  attendeeType?: string;
}): boolean {
  const type = (reg.attendeeType ?? "").toLowerCase();
  return type === "guest" || type === "invited_guest";
}

function firmFromRegistrationName(reg: IRegistration): IFirm | undefined {
  const name = reg.firmName?.trim();
  if (!name) {
    return undefined;
  }
  return { firmName: name, name } as IFirm;
}

function firmFromCompany(company: { id: string; name: string }): IFirm {
  return { id: company.id, firmName: company.name, name: company.name } as IFirm;
}

/**
 * Guest registrations store a Company id in firmId. Firm attendees use a real Firm id.
 * Falls back to denormalized registration.firmName when lookup fails.
 */
export async function resolveBillingFirmForRegistration(
  registration: IRegistration,
): Promise<IFirm | undefined> {
  const orgId = registration.firmId?.trim();
  if (!orgId) {
    return firmFromRegistrationName(registration);
  }

  if (isGuestAttendeeRegistration(registration)) {
    const company = await getCompanyById(orgId);
    if (company?.name) {
      return firmFromCompany(company);
    }
  }

  try {
    const firm = await getFirmById(orgId);
    if (firm?.firmName || firm?.name) {
      return firm;
    }
  } catch {
    // firmId may reference a company or other non-firm entity
  }

  const company = await getCompanyById(orgId);
  if (company?.name) {
    return firmFromCompany(company);
  }

  return firmFromRegistrationName(registration);
}
